module.exports = __webpack_public_path__ + "img/Coupé_mobile.e92fd944.jpg";